import { render, staticRenderFns } from "./makeInvoiceAction.vue?vue&type=template&id=4b1c72e4&scoped=true"
import script from "./makeInvoiceAction.vue?vue&type=script&lang=js"
export * from "./makeInvoiceAction.vue?vue&type=script&lang=js"
import style0 from "./makeInvoiceAction.vue?vue&type=style&index=0&id=4b1c72e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c72e4",
  null
  
)

export default component.exports